import Loading from '../../ui/Loading';
import ErrorMessage from '../../ui/ErrorMessage';
import { useQueryData } from '../../../hooks/api/useQueryData';
import CategoryAndProductTHead from '../../common/theads/CategoryAndProductTHead';
import { useMemo } from 'react';
import CategoryAndProductHeader from '../../common/headers/CategoryAndProductHeader';

export default function CategoryAndProduct() {

    const { productBaseOnCategory, isErrorProductBaseOnCategory, isLoadingProductBaseOnCategory, errorMessageProductBaseOnCategory } = useQueryData()

    const sortedProducts = useMemo(() => {
        return [...(productBaseOnCategory ?? [])].sort((a, b) => {
            const catA = a.categoryInfo?.categoryName?.toLowerCase() || "";
            const catB = b.categoryInfo?.categoryName?.toLowerCase() || "";
            const categoryCompare = catA.localeCompare(catB);

            if (categoryCompare !== 0) return categoryCompare;

            const sizeA = a.sizeInfo?.size?.toLowerCase() || "";
            const sizeB = b.sizeInfo?.size?.toLowerCase() || "";

            const isNoneA = sizeA === "" || sizeA === "none";
            const isNoneB = sizeB === "" || sizeB === "none";

            if (isNoneA && !isNoneB) return 1;
            if (!isNoneA && isNoneB) return -1;

            if (sizeA.length !== sizeB.length) {
                return sizeA.length - sizeB.length;
            }

            return sizeA.localeCompare(sizeB);
        });
    }, [productBaseOnCategory]);

    return (
        <div className='fixed m-0 p-0 inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[100]'>
            <div className='relative w-[90%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[75%] lg:max-w-[70%] lg:mx-auto'>
                <div className='flex flex-col w-full'>
                    <div className='py-5 overflow-hidden rounded'>
                        <CategoryAndProductHeader/>
                        <hr className="h-px bg-gray-200 border-0" />
                        <div className='h-full overflow-hidden'>
                            <CategoryAndProductTHead/>
                            <div className='overflow-hidden h-full rounded'>
                                <div className="max-h-80 overflow-y-auto rounded">
                                    <div className="px-2 h-full rounded overflow-y-auto ">
                                        {isLoadingProductBaseOnCategory ? (
                                            <div className='w-full flex justify-center'>
                                                <Loading message="Loading product..." />
                                            </div>
                                        ) : isErrorProductBaseOnCategory ? (
                                            <ErrorMessage message={errorMessageProductBaseOnCategory} />
                                        ) : productBaseOnCategory?.length === 0 ? (
                                            <div className='w-full flex justify-center'>
                                                No product found.
                                            </div>
                                        ) : (
                                            <>     
                                                <div className="grid grid-cols-1 gap-2">
                                                    {sortedProducts.map((product) => {
                                                        const firstWord = product.categoryInfo?.categoryName?.split(" ")[0] || "";
                                                        const addons = product.addons ?? [];
                                                        return (
                                                            <div key={product.productID} className={`cursor-pointer transition-colors rounded`}>
                                                                <div className="border border-gray-200 flex flex-col p-2.5 space-y-1 rounded bg-gray-100 transition-colors">
                                                                    {/* <div className="grid [grid-template-columns:2fr_1fr_0.5fr_0.5fr_auto] gap-2 w-full text-[12px] items-center"> */}
                                                                    <div className="grid grid-cols-12 gap-2 w-full text-[12px] items-center">
                                                                        <div className="col-span-4 font-medium truncate">{`${firstWord} | ${product.productName}`}</div>
                                                                        <div className="col-span-2 truncate">{`${product.isAvailable ? 'Yes' : 'No'}`}</div>
                                                                        <div className="col-span-1 truncate">{product.sizeInfo.size === 'None' ? '' : product.sizeInfo.size}</div>
                                                                        <div className="col-span-2 truncate">{product.price}</div>
                                                                        <div className="col-span-3 mt-1 flex flex-col text-[11px] text-gray-600">
                                                                            {addons.map((add) => (
                                                                                <div key={add.addonID}>{add.addonName}</div>
                                                                            ))}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
